import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n'

const configTable = () => {
  const Table = { ...Tables.Table };
  const firstColumn = [
    {
      prop: 'sensors_stations.station.code_station',
      minWidth: 120,
      label: i18n.t('devices.station_code'),
      sortable: true,
      fixed: true,
    },
    {
      prop: 'sensors_stations.station.name',
      label: i18n.t('devices.station'),
      minWidth: 120,
      sortable: true,
      fixed: true,
    },
    {
      prop: 'sensors_stations.sensor.two_name',
      label: i18n.t('devices.sensor'),
      minWidth: 120,
      sortable: true,
      fixed: true,
    },
  ];

  const formatterFuction = (row, column) => {
    if (typeof Number(row[column.property]) === 'number')
      return row[column.property];
    else {
      return Number(row[column.property]) === 0
        ? '0'
        : Formatter.formatNumber(Number(row[column.property]));
    }
  };

  Table.heatColumnTable = [
    ...firstColumn,
    {
      prop: 'formatted_date',
      label: i18n.t('common_words.time_interval'),
      minWidth: 120,
      sortable: true,
      fixed: true,
    },
    {
      label: i18n.t('labor.hour_degree'),
      prop: 'degreeHours',
      align: 'center',
      formatter: formatterFuction,
    },
    {
      label: i18n.t('common_words.day_average_degree'),
      prop: 'degreeDays',
      align: 'center',
      formatter: formatterFuction,
    },
    {
      label: i18n.t('common_words.day_degree'),
      prop: 'degreeDaysAcc',
      align: 'center',
      formatter: formatterFuction,
    },
  ];

  Table.coldColumnTable = [
    ...firstColumn,
    {
      prop: 'date',
      label: i18n.t('common_words.time_interval'),
      minWidth: 130,
      sortable: true,
      fixed: true,
    },
    {
      label: i18n.t('labor.h_number'),
      prop: 'numberHours',
      align: 'center',
      minWidth: 120,
      formatter: formatterFuction,
    },
    {
      label: i18n.t('common_words.degree_random'),
      prop: 'hours72C',
      align: 'center',
      minWidth: 120,
      formatter: formatterFuction,
    },
    {
      label: i18n.t('common_words.cooling_hours_utah'),
      prop: 'utah',
      align: 'center',
      minWidth: 120,
      formatter: formatterFuction,
    },
    {
      label: i18n.t('common_words.positive_cu_utah'),
      prop: 'pcuUtah',
      align: 'center',
      minWidth: 120,
      formatter: formatterFuction,
    },
  ];

  Table.rainColumnTable = [
    ...firstColumn,
    {
      prop: 'formatted_date',
      label: i18n.t('common_words.time_interval'),
      minWidth: 130,
      sortable: true,
      fixed: true,
    },
    {
      label: i18n.t('climate.rain_addition_unit'),
      prop: 'sum',
      align: 'center',
      minWidth: 120,
      formatter: formatterFuction,
    },
  ];

  return { Table, formatterFuction };
}

export default configTable;
